<ion-header *ngIf="type == 'modal'" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" (click)="close()"></ion-back-button>
    </ion-buttons>
    <ion-title>Adresse auswählen</ion-title>
    <ion-buttons slot="end">
      <ion-button slot="icon-only" (click)="addCrm()" style="box-shadow: none">
        <ion-icon name="fa-plus"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollEvents]="true" class="ion-padding" NoScrollbar ArrowKeyUseable [arrowKeysOptions]="arrowKeysOptions" [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}" [class.popover]="type == 'popover'" [class.modal]="type == 'modal'">
  <div id="content"  >
    <div class="search">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="search-icon svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
      <input #search type="search" class="search-input" placeholder="Suchen..." (keyup)="setFilter($event)" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)" [(ngModel)]="filterValue"/>
    </div>
    <ion-list *ngIf="!loading" >
      <ion-item class="item" *ngFor="let kunde of addresses; let i = index" (click)="select(kunde)" (mouseenter)="arrowKeysOptions.mouseOverItem.next(i)" (mousemove)="arrowKeysOptions.mouseMove.next(true)">

        <ion-label>
          <div>
            <h4 *ngIf="kunde.number">Nr.: {{kunde.number}}</h4>
            <h2>{{kunde.description}}</h2>
          </div>
        </ion-label>

        <div class="hover-bttn" slot="end" (click)="openAddressDetails($event, kunde)">
          <ion-icon name="fa-open-new"></ion-icon>
        </div>
        
      </ion-item>
      <div class="no-content" style="margin: 15px 0;" *ngIf="addresses.length == 0 && !loading">
        Kein Adresse gefunden
      </div>
    </ion-list>
  
    <section id="skeleton" *ngIf="loading">
      <div class="custom-skeleton loading-item" *ngFor="let l of loadingCount">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
      </div>
    </section>
  </div>
</ion-content>
